import { useRef } from "react";
import { Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import mainSlideArrowLeftIcon from "../../../assets/images/home/mainSlideArrowLeft.png";
import mainSlideArrowRightIcon from "../../../assets/images/home/mainSlideArrowRight.png";
import { educationSlides } from "../../../data/education";
import Icon from "../../Icon";
import * as S from "./styled";

const EducationSlide = () => {
  const EducationSlidePrevRef = useRef<HTMLButtonElement | null>(null);
  const EducationSlideSlideNextRef = useRef<HTMLButtonElement | null>(null);
  return (
    <S.ContentsSlideContainer
      data-aos="fade"
      data-aos-duration={600}
      data-aos-easing="linear"
    >
      <S.EducationSlidePrevButton ref={EducationSlidePrevRef}>
        <Icon>
          <img src={mainSlideArrowLeftIcon} alt="logo" />
        </Icon>
      </S.EducationSlidePrevButton>
      <Swiper
        modules={[Navigation]} // Navigation 모듈 추가
        spaceBetween={0}
        slidesPerView={1}
        navigation={{
          prevEl: EducationSlidePrevRef.current,
          nextEl: EducationSlideSlideNextRef.current,
        }}
        onSwiper={(swiper: any) => {
          setTimeout(() => {
            if (swiper?.params?.navigation) {
              // Swiper가 초기화된 후 버튼을 다시 연결
              Object.assign(swiper.params.navigation, {
                prevEl: EducationSlidePrevRef.current,
                nextEl: EducationSlideSlideNextRef.current,
              });
              swiper.navigation.init();
              swiper.navigation.update();
            }
          });
        }}
      >
        {educationSlides.map((homeContent, index) => (
          <SwiperSlide key={index}>
            <S.EducationSlideWrapper>
              <S.EducationSlideImgWrap>
                <img src={homeContent.img} alt="education slide" />
              </S.EducationSlideImgWrap>
            </S.EducationSlideWrapper>
          </SwiperSlide>
        ))}
      </Swiper>

      <S.EducationSlideNextButton ref={EducationSlideSlideNextRef}>
        <Icon>
          <img src={mainSlideArrowRightIcon} alt="logo" />
        </Icon>
      </S.EducationSlideNextButton>
    </S.ContentsSlideContainer>
  );
};

export default EducationSlide;
